import DdTextBox from '@/components/DdTextBox'
import DdDefaultButton from '@/components/DdDefaultButton'

import flowMixin from '@/mixins/flowMixins'

import { mapGetters } from 'vuex'

export default {
  name: 'JuchuEditDialog',
  mixins: [flowMixin],
  components: {
    DdTextBox,
    DdDefaultButton
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * 受注基本ID
     */
    juchuKihonId: Number
  },
  data: () => ({
    juchuNo: ''
  }),
  created () {
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({}),
    computedProps () {
      return {
        ...this.$props,
        persistent: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    }
  },
  watch: {
    showDialog: function () {
      if (this.showDialog) {
        this.HttpClient
          .get(`/api/v1/TrJuchuKihon/find?id=${this.juchuKihonId}`)
          .then((data) => {
            this.rec = data.payload
            this.juchuNo = this.rec.juchuNo
          })
      }
    }
  },
  methods: {
    initialize: function () {
      const opt = {
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('●juchuEditDialog.defineHeaderPromise')
            resolve()
          })
        },
        initializeInputPromise: this.clear(),
        savedInputRestorePromise: (c) => {
          console.log('●juchuEditDialog.savedInputRestorePromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        researchPromise: (c) => {
          console.log('●juchuEditDialog.researchPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('●juchuEditDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('●juchuEditDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        getCloneTargetMethod: function () {
          return {
            rec: this.rec
          }
        }
      }
      this.initializeForViewer(opt)
    },
    clear: function () {
      console.log('clear')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.juchuNo = ''
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onCloseClick: function (e) {
      console.log('close clicked', this.showDialog)
      this.clear()
      this.$emit('close')
    }
  }
}
